import WithSidebar from "../../layouts/WithSidebar";
import CalculatorForm from '../../components/Calculator'

const Calculator = () => {




    return (
        <WithSidebar pageTitle={"Excess Baggage Calculator"} breadcrumb={"Dashboard > Calculator"}>
            <CalculatorForm />
        </WithSidebar>
    )
}

export default Calculator